function Loading({full}) {
    if (full) {
        return (
            <div className="loading--full">
                <div className="loading"/>
            </div>
        );
    }

    return (
        <div className="loading"/>
    );
}

export default Loading;
